import React from 'react';
import { SUPPORT_EMAIL } from '../data/content';
const links = [{
  label: 'Términos y Condiciones',
  href: '#terminos'
}, {
  label: 'Política de Privacidad',
  href: '#privacidad'
}];
export function Footer() {
  return <footer className="bg-navy" data-id="element-69" data-mp="32p5m4f11ouo9">
      <div className="mx-auto max-w-2xl px-3 py-4 pb-20 text-center sm:px-4 sm:pb-5" data-id="element-70" data-mp="32lrnnhvi55m3">
        <p className="text-xs text-white/85" data-id="element-71" data-mp="36ppjnjpj60ax">© 2026 — Todos los Derechos Reservados.</p>
        <p className="mt-1 text-[0.66rem] leading-snug text-white/65" data-id="element-72" data-mp="3ufjuxwu7bgt2">
          MEGA PACK INSTALADOR DE REDES WiFi Y CABLEADO DESDE CERO™ es un
          producto educativo. No sustituye formación profesional, práctica
          supervisada, manuales de fabricantes, normativa técnica aplicable,
          licencias, certificaciones, permisos ni el criterio de un profesional
          habilitado cuando corresponda. Toda instalación debe realizarse sobre
          redes y equipos propios o expresamente autorizados, siguiendo las
          instrucciones oficiales de los fabricantes y las normas de seguridad
          aplicables.
        </p>
        <p className="mt-1 text-xs text-white/85" data-id="element-73" data-mp="3gapb9dmj6adc">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-amarillo underline-offset-2 hover:underline" data-id="element-74" data-mp="3gctqgrpvqvsx">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1" data-id="element-75" data-mp="830jhjn6y710">
          <ul className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-white/85" data-id="element-76" data-mp="81fnrqp54i1k">
            {links.map((link, i) => <li key={link.label} className="flex items-center gap-2" data-id="element-77" data-mp="hsk4ovydmcz1" data-mpi={i}>
                {i > 0 && <span aria-hidden="true" data-id="element-78" data-mp="huo4p2t5mru1">•</span>}
                <a href={link.href} className="whitespace-nowrap transition-colors duration-150 ease-soft hover:text-amarillo" data-id="element-79" data-mp="cus3fbbudei6">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>
    </footer>;
}